var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid margin-9apuap"},[_c('h1',[_vm._v("Contact Info")]),_c('p',[_vm._v("Legal address:Themistokli Dervi, 17-19 THE CITY HOUSE, 2nd floor 1066, Nicosia,\n      Cyprus")])])
}]

export { render, staticRenderFns }